import * as React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { getNestedFieldValue } from '../../../lib/utils';
import { ErrorDecorator } from '../../../commonComponents/ErrorMessage';

const FieldError = ({ fieldName }: Props) => {
	const { formState, control } = useFormContext();
	// Watch the field not because we use its value, but because we use its error.
	// This will cause the component to re-render appropriately when an error is created.
	useWatch({ name: fieldName, control });
	const errorMessage = getNestedFieldValue(formState.errors, fieldName)?.message; // ?? formState.errors[fieldName]?.message;
	return <ErrorDecorator>{errorMessage}</ErrorDecorator>;
};

interface Props {
	fieldName: string;
}

export default FieldError;
